<script setup lang="ts">
    import type { PageProductSummaryFragment } from '~/graphql/generated';

    interface ProductSuccessorProps {
        titleOld: string | undefined | null;
        link: LinkData;
    }

    const props = defineProps<ProductSuccessorProps>();
    const { queryParams } = usePreview();
    const { locale } = useLocales();
    const { resolveUrlLink } = useURL();

    const url = resolveUrlLink(props.link);

    const { data: requestData } = useAsyncData<PageProductSummaryFragment>(`product-summary-sitemap:${url.url}`, () =>
        $fetch('/api/product-summary-sitemap', {
            query: {
                url: url.url,
                locale: locale.value,
                ...queryParams.value,
            },
        }),
    );
    const { title } = useProductSummary(requestData);
</script>

<template>
    <div class="flex flex-col gap-4 rounded-md bg-woom-grey p-4 text-center">
        <i18n-t
            keypath="product.successorMessage"
            class="px-4 text-center"
            tag="span">
            <template v-slot:oldProductTitle>
                <renderer-html
                    v-if="titleOld"
                    :content="woomTextFormat(titleOld)" />
            </template>
            <template v-slot:newProductTitle>
                <renderer-html
                    v-if="title"
                    :content="woomTextFormat(title)" />
            </template>
        </i18n-t>
        <lazy-atm-button
            :to="url.url"
            kind="link"
            styling="solid-secondary"
            block>
            {{ url.label }}
        </lazy-atm-button>
    </div>
</template>
<style scoped></style>
